<template>
	<div class="d-flex flex-column gap-3">
		<div class="d-flex flex-column flex-md-row gap-3">
			<div class="form-floating flex-fill">
				<input type="text" v-model="name" id="name" class="form-control bg-white" :placeholder="$t('general.contact.name')">
				<label for="name">{{ $t('general.contact.name') }}</label>
			</div>
			<div class="form-floating flex-fill">
				<input type="email" v-model="email" id="email" class="form-control bg-white" :placeholder="$t('general.contact.email')">
				<label for="email">{{ $t('general.contact.email') }}</label>
			</div>
			<div class="form-floating flex-fill">
				<select v-model="selectedSubject" id="subject" class="form-select bg-white">
					<option :value="0" selected disabled>{{ $t('general.choose') }}</option>
					<option v-for="subject in contactSubjects" :key="'subject_'+subject.id" :value="subject.id">{{ subject.subject }}</option>
					<option :value="null">{{ $t('general.other') }}</option>
				</select>
				<label for="subject">{{ $t('general.contact.subject') }}</label>
			</div>
			<div v-if="selectedSubject === null" class="form-floating flex-fill">
				<input type="text" v-model="customSubject" id="custom_subject" class="form-control bg-white" :placeholder="$t('general.contact.subject')">
				<label for="custom_subject">{{ $t('general.contact.subject') }}</label>
			</div>
		</div>
		<div class="form-floating">
			<textarea v-model="message" id="message" class="form-control bg-white" style="height: 200px;" :placeholder="$t('general.contact.message')"></textarea>
			<label for="message">{{ $t('general.contact.message') }}</label>
		</div>
		<button type="button" class="btn btn-success" @click="send" :disabled="selectedSubject === 0">
			<i class="fa-solid fa-envelope me-2"></i>
			{{ $t('general.send') }}
		</button>
	</div>
</template>

<script>
import {ref,reactive} from 'vue'
import axios from 'axios'

export default {
	name: "compose",
	props: {
		contactSubjects: Array
	},
	setup(props){
		const name = ref("")
		const email = ref("")
		const message = ref("")
		const customSubject = ref("")
		const selectedSubject = ref(0)
		const contactSubjects = reactive(props.contactSubjects)
		return {
			name,
			email,
			message,
			customSubject,
			selectedSubject,
			contactSubjects
		}
	},
	methods: {
		send(){
			axios.post(this.route('contact.send'), {
				name: this.name,
				email: this.email,
				message: this.message,
				custom_subject: this.customSubject,
				contact_subject_id: this.selectedSubject,
			}).then(({data}) => {
				if(data.res){
					window.showSuccess(data.text)
				}
			}).catch(window.showValidationErrors)
		}
	}
}
</script>
